import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-string-readonly',
  templateUrl: 'field-string-readonly.component.html',
  styleUrls: ['field-string-readonly.component.scss']
})
export class FieldStringReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }

  get value() {
    return this.field.value?.data || [];
  }

}
